var _clipPath, _clipPath2, _clipPath3, _clipPath4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 428.005 434.24",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath20",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M 0,0 H 5000 V 5000 H 0 Z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath48",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "m 1568.71,2253.18 c -2.73,0 -5.51,0.32 -8.33,1 -39.04,9.38 -77.62,25.08 -114.48,48.35 -69.04,43.6 -120.8,107.13 -150.95,179.43 30.19,-72.04 81.84,-135.34 150.69,-178.81 36.86,-23.27 75.44,-38.96 114.48,-48.35 2.82,-0.68 5.61,-0.99 8.34,-0.99 3.9,0 7.69,0.64 11.28,1.77 1.62,48.86 6.41,97.37 14.26,145.23 0.13,-0.03 0.25,-0.07 0.38,-0.11 -7.9,-48.03 -12.75,-96.71 -14.38,-145.75 -3.6,-1.12 -7.39,-1.77 -11.29,-1.77"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient54",
    spreadMethod: "pad",
    gradientTransform: "matrix(3250.27,0,0,-3252.88,2500,2500.13)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop50",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#e4e4e1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop52",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#d6d5d1"
    }
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath68",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path66",
    d: "m 3469.5,3050.95 c -36.02,33.32 -74.04,64.1 -113.74,92.26 0.06,0.12 0.12,0.23 0.18,0.35 39.55,-28.08 77.41,-58.78 113.29,-91.99 5.65,3 10.71,7.37 14.35,13.41 20.78,34.36 36.75,72.82 46.12,115.39 17.57,79.79 8.76,161.3 -21.47,233.61 30.43,-72.46 39.34,-154.22 21.73,-234.23 -9.37,-42.57 -25.34,-81.04 -46.12,-115.4 -3.64,-6.04 -8.69,-10.4 -14.34,-13.4"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient74",
    spreadMethod: "pad",
    gradientTransform: "matrix(3250.27,0,0,-3252.88,2500,2500.13)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop70",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#e4e4e1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop72",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#d6d5d1"
    }
  })), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath124",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path122",
    d: "m 2172.45,2905.66 0.02,0.02 -0.02,-0.02 m 0.77,0.62 0.03,0.02 -0.03,-0.02 m 0.78,0.62 0.03,0.02 -0.03,-0.02 m 0.77,0.61 0.01,0.01 -0.01,-0.01 m 0.72,0.57 c 0.03,0.03 0.06,0.05 0.09,0.08 -0.03,-0.03 -0.06,-0.05 -0.09,-0.08 m 0.76,0.6 c 0.03,0.03 0.09,0.08 0.13,0.1 -0.07,-0.05 -0.07,-0.05 -0.13,-0.1 m 0.75,0.6 c 0.07,0.05 0.12,0.09 0.18,0.14 -0.07,-0.06 -0.11,-0.09 -0.18,-0.14 m 0.78,0.61 c 0.06,0.05 0.13,0.1 0.19,0.15 -0.07,-0.05 -0.12,-0.1 -0.19,-0.15 m 0.78,0.61 c 0.06,0.05 0.15,0.12 0.21,0.17 -0.07,-0.05 -0.14,-0.11 -0.21,-0.17 m 0.78,0.61 c 0.06,0.06 0.17,0.14 0.23,0.19 -0.07,-0.06 -0.16,-0.13 -0.23,-0.19 m 0.78,0.62 c 0.1,0.07 0.16,0.12 0.26,0.2 -0.11,-0.08 -0.16,-0.12 -0.26,-0.2 m 0.79,0.61 c 0.09,0.08 0.17,0.14 0.27,0.21 -0.1,-0.08 -0.17,-0.13 -0.27,-0.21 m 0.7,0.54 c 0.13,0.11 0.25,0.2 0.38,0.3 -0.13,-0.1 -0.25,-0.19 -0.38,-0.3 m 0.74,0.58 c 0.13,0.11 0.32,0.25 0.45,0.35 -0.14,-0.11 -0.31,-0.24 -0.45,-0.35 m 0.78,0.61 c 0.13,0.1 0.34,0.26 0.47,0.36 -0.13,-0.1 -0.33,-0.26 -0.47,-0.36 m 0.78,0.6 c 0.16,0.12 0.36,0.28 0.53,0.41 -0.17,-0.14 -0.36,-0.28 -0.53,-0.41 m 0.78,0.6 c 0.19,0.15 0.37,0.28 0.57,0.44 -0.18,-0.14 -0.4,-0.31 -0.57,-0.44 m 0.79,0.61 c 0.2,0.15 0.43,0.33 0.63,0.48 -0.21,-0.16 -0.42,-0.32 -0.63,-0.48 m 0.8,0.61 c 0.23,0.17 0.51,0.39 0.74,0.57 -0.27,-0.21 -0.47,-0.36 -0.74,-0.57 m 0.8,0.61 c 0.95,0.73 1.93,1.47 2.89,2.2 -0.97,-0.73 -1.93,-1.46 -2.89,-2.2 m 2.9,2.21 c 62.06,46.98 132.24,86.1 210.21,115.17 -77.98,-29.07 -148.14,-68.19 -210.21,-115.17 m 210.22,115.18 c 0.34,0.12 0.68,0.25 1.01,0.37 -0.35,-0.13 -0.66,-0.24 -1.01,-0.37 m 1.09,0.4 c 0.33,0.12 0.6,0.22 0.93,0.35 -0.34,-0.13 -0.58,-0.22 -0.93,-0.35 m 1.05,0.39 c 0.33,0.12 0.6,0.22 0.93,0.34 -0.35,-0.12 -0.59,-0.21 -0.93,-0.34 m 1.02,0.38 c 0.34,0.12 0.66,0.24 0.99,0.36 -0.35,-0.13 -0.64,-0.23 -0.99,-0.36 m 1.02,0.37 c 0.33,0.12 0.68,0.25 1.01,0.37 -0.35,-0.13 -0.66,-0.24 -1.01,-0.37 m 1.05,0.39 c 1.21,0.44 2.44,0.88 3.65,1.32 -1.22,-0.44 -2.43,-0.88 -3.65,-1.32 m 3.71,1.34 c 0.33,0.12 0.63,0.23 0.96,0.35 -0.35,-0.13 -0.61,-0.22 -0.96,-0.35 m 1.13,0.41 c 0.3,0.1 0.57,0.2 0.86,0.31 -0.3,-0.11 -0.55,-0.2 -0.86,-0.31 m 1.05,0.37 c 0.29,0.11 0.55,0.2 0.85,0.31 -0.27,-0.1 -0.59,-0.21 -0.85,-0.31 m 1.03,0.37 c 0.29,0.1 0.57,0.2 0.86,0.31 -0.26,-0.1 -0.6,-0.22 -0.86,-0.31 m 1.04,0.37 c 0.25,0.09 0.55,0.2 0.81,0.29 -0.27,-0.1 -0.55,-0.2 -0.81,-0.29 m 1.07,0.38 c 0.25,0.09 0.51,0.18 0.76,0.27 -0.26,-0.1 -0.5,-0.18 -0.76,-0.27 m 1.04,0.36 c 0.25,0.09 0.44,0.16 0.69,0.25 -0.22,-0.08 -0.47,-0.17 -0.69,-0.25 m 1.04,0.37 c 0.21,0.07 0.42,0.14 0.63,0.22 -0.18,-0.06 -0.45,-0.16 -0.63,-0.22 m 1.04,0.36 c 0.17,0.06 0.28,0.1 0.45,0.16 -0.17,-0.06 -0.27,-0.1 -0.45,-0.16 m 1.04,0.36 c 0.16,0.06 0.28,0.1 0.45,0.16 -0.18,-0.06 -0.28,-0.1 -0.45,-0.16 m 1.02,0.36 c 0.17,0.06 0.3,0.1 0.46,0.16 -0.17,-0.06 -0.28,-0.1 -0.46,-0.16 m 0.94,0.32 c 0.17,0.06 0.38,0.13 0.55,0.19 -0.17,-0.06 -0.37,-0.13 -0.55,-0.19 m 0.97,0.34 c 0.22,0.07 0.4,0.13 0.61,0.21 -0.22,-0.08 -0.38,-0.14 -0.61,-0.21 m 1.02,0.34 c 0.21,0.08 0.41,0.14 0.62,0.22 -0.22,-0.08 -0.4,-0.14 -0.62,-0.22 m 1.04,0.36 c 0.17,0.06 0.41,0.14 0.58,0.2 -0.17,-0.06 -0.41,-0.14 -0.58,-0.2 m 1.04,0.35 c 0.17,0.06 0.39,0.13 0.56,0.19 -0.18,-0.06 -0.39,-0.13 -0.56,-0.19 m 1.03,0.35 c 0.17,0.06 0.37,0.12 0.54,0.18 -0.18,-0.06 -0.36,-0.12 -0.54,-0.18 m 1.03,0.35 c 0.17,0.05 0.32,0.11 0.49,0.16 -0.17,-0.06 -0.31,-0.1 -0.49,-0.16 m 1.03,0.34 c 0.13,0.05 0.28,0.1 0.4,0.14 -0.13,-0.05 -0.26,-0.09 -0.4,-0.14 m 1.05,0.35 c 0.13,0.05 0.25,0.09 0.37,0.13 -0.13,-0.05 -0.24,-0.08 -0.37,-0.13 m 1.04,0.35 c 0.17,0.06 0.21,0.07 0.38,0.13 -0.13,-0.05 -0.25,-0.09 -0.38,-0.13 m 1.03,0.34 c 0.13,0.04 0.25,0.08 0.38,0.13 -0.14,-0.05 -0.24,-0.08 -0.38,-0.13 m 1.06,0.35 c 0.13,0.04 0.22,0.07 0.34,0.11 -0.13,-0.04 -0.2,-0.07 -0.34,-0.11 m 1.04,0.34 c 0.13,0.04 0.21,0.07 0.33,0.11 -0.13,-0.04 -0.19,-0.06 -0.33,-0.11 m 1.03,0.34 c 0.13,0.04 0.2,0.06 0.33,0.1 -0.09,-0.02 -0.24,-0.07 -0.33,-0.1 m 0.95,0.31 c 0.17,0.05 0.24,0.08 0.41,0.13 -0.13,-0.04 -0.28,-0.09 -0.41,-0.13 m 1,0.32 c 0.17,0.06 0.26,0.09 0.43,0.14 -0.18,-0.06 -0.25,-0.08 -0.43,-0.14 m 1.02,0.33 c 0.13,0.04 0.28,0.09 0.41,0.13 -0.14,-0.04 -0.27,-0.08 -0.41,-0.13 m 1.04,0.34 c 0.13,0.04 0.18,0.06 0.31,0.1 -0.09,-0.03 -0.22,-0.07 -0.31,-0.1 m 1.03,0.33 c 0.13,0.04 0.2,0.06 0.33,0.1 -0.13,-0.04 -0.19,-0.06 -0.33,-0.1 m 1.06,0.33 c 0.09,0.03 0.22,0.07 0.31,0.1 -0.09,-0.03 -0.22,-0.07 -0.31,-0.1 m 1.04,0.33 c 0.09,0.03 0.23,0.08 0.31,0.1 -0.09,-0.03 -0.22,-0.07 -0.31,-0.1 m 1.06,0.34 c 0.09,0.03 0.2,0.06 0.28,0.09 -0.09,-0.03 -0.19,-0.06 -0.28,-0.09 m 1.03,0.32 c 0.09,0.03 0.22,0.07 0.31,0.1 -0.14,-0.04 -0.17,-0.05 -0.31,-0.1 m 1.06,0.34 c 0.09,0.02 0.19,0.06 0.28,0.08 -0.09,-0.03 -0.19,-0.06 -0.28,-0.08 m 1.05,0.32 c 0.08,0.03 0.18,0.06 0.27,0.09 -0.09,-0.03 -0.18,-0.06 -0.27,-0.09 m 1.01,0.32 c 0.09,0.02 0.19,0.06 0.28,0.08 -0.09,-0.03 -0.19,-0.05 -0.28,-0.08 m 0.98,0.3 c 0.09,0.03 0.25,0.08 0.33,0.1 -0.09,-0.03 -0.23,-0.07 -0.33,-0.1 m 1.05,0.32 c 0.09,0.03 0.16,0.05 0.24,0.08 -0.04,-0.02 -0.19,-0.06 -0.24,-0.08 m 1.04,0.32 c 0.09,0.03 0.14,0.04 0.22,0.07 -0.09,-0.03 -0.13,-0.04 -0.22,-0.07 m 1.08,0.33 c 0.08,0.03 0.09,0.03 0.17,0.05 -0.04,-0.01 -0.13,-0.04 -0.17,-0.05 m 1.02,0.31 c 0.09,0.03 0.14,0.04 0.23,0.07 -0.05,-0.01 -0.18,-0.05 -0.23,-0.07 m 1.05,0.32 c 0.08,0.02 0.13,0.04 0.22,0.07 -0.09,-0.03 -0.13,-0.04 -0.22,-0.07 m 1.04,0.31 c 0.09,0.03 0.15,0.05 0.24,0.07 -0.09,-0.02 -0.15,-0.04 -0.24,-0.07 m 1.07,0.32 c 0.08,0.03 0.11,0.04 0.2,0.06 -0.05,-0.01 -0.16,-0.04 -0.2,-0.06 m 1.05,0.32 c 0.08,0.02 0.12,0.03 0.21,0.06 -0.05,-0.01 -0.17,-0.05 -0.21,-0.06 m 1.06,0.31 c 0.05,0.02 0.12,0.04 0.16,0.05 -0.09,-0.03 -0.07,-0.02 -0.16,-0.05 m 1.07,0.32 c 0.04,0.01 0.07,0.02 0.11,0.03 -0.04,-0.01 -0.07,-0.02 -0.11,-0.03 m 1.07,0.31 0.02,0.01 -0.02,-0.01 m 0.97,0.29 c 0.05,0.01 0.06,0.02 0.11,0.03 -0.05,-0.01 -0.06,-0.02 -0.11,-0.03 m 1.03,0.3 c 0.04,0.01 0.09,0.02 0.13,0.04 -0.04,-0.02 -0.09,-0.03 -0.13,-0.04 m 1.04,0.3 c 0.05,0.01 0.11,0.03 0.15,0.04 -0.04,-0.01 -0.1,-0.03 -0.15,-0.04 m 1.05,0.3 c 0.09,0.03 0.08,0.03 0.16,0.05 -0.04,-0.01 -0.12,-0.03 -0.16,-0.05 m 1.04,0.3 c 0.09,0.03 0.1,0.03 0.19,0.06 -0.05,-0.02 -0.14,-0.04 -0.19,-0.06 m 1.05,0.3 c 0.09,0.03 0.11,0.04 0.2,0.06 -0.09,-0.03 -0.1,-0.03 -0.2,-0.06 m 1.08,0.31 c 0.09,0.03 0.07,0.02 0.16,0.05 -0.05,-0.02 -0.12,-0.04 -0.16,-0.05 m 1.07,0.3 c 0.04,0.02 0.09,0.03 0.13,0.04 -0.05,-0.01 -0.08,-0.02 -0.13,-0.04 m 1.06,0.31 c 0.05,0.01 0.08,0.02 0.12,0.03 l -0.12,-0.03 m 1.07,0.29 0.09,0.03 c -0.04,-0.01 -0.05,-0.01 -0.09,-0.03 m 1.06,0.3 0.06,0.02 -0.06,-0.02 m 1.04,0.29 0.05,0.01 c -0.05,-0.01 -0.01,0 -0.05,-0.01 m 1.02,0.28 0.1,0.03 c -0.05,-0.01 -0.05,-0.01 -0.1,-0.03 m 1.04,0.29 c 0.04,0.01 0.09,0.03 0.13,0.04 -0.04,-0.02 -0.08,-0.03 -0.13,-0.04 m 1.07,0.29 c 0.04,0.01 0.08,0.02 0.12,0.04 -0.05,-0.02 -0.08,-0.02 -0.12,-0.04 m 1.07,0.3 0.1,0.02 c -0.04,-0.01 -0.05,-0.01 -0.1,-0.02 m 1.06,0.28 0.11,0.04 -0.11,-0.04 m 1.06,0.29 0.11,0.03 c -0.04,-0.01 -0.06,-0.01 -0.11,-0.03 m 1.07,0.29 c 0.04,0.01 0.07,0.02 0.11,0.03 -0.05,-0.01 -0.07,-0.02 -0.11,-0.03 m 1.07,0.29 0.09,0.02 -0.09,-0.02 m 1.08,0.28 0.06,0.02 c -0.05,-0.01 -0.02,-0.01 -0.06,-0.02 m 2.12,0.57 h 0.02 -0.02 m 1.07,0.27 0.02,0.01 c -0.05,-0.01 0.02,0.01 -0.02,-0.01 m 1.05,0.28 0.04,0.01 -0.04,-0.01 m 1.05,0.27 0.07,0.02 c -0.04,-0.01 -0.03,-0.01 -0.07,-0.02 m 1.05,0.28 0.1,0.02 c -0.04,-0.01 -0.05,-0.01 -0.1,-0.02 m 1.08,0.27 0.09,0.03 -0.09,-0.03 m 1.06,0.27 0.12,0.03 c -0.05,-0.01 -0.07,-0.01 -0.12,-0.03 m 1.08,0.28 0.11,0.03 c -0.05,-0.02 -0.06,-0.02 -0.11,-0.03 m 1.08,0.27 0.08,0.02 -0.08,-0.02 m 1.1,0.28 h 0.02 -0.02 m 3.18,0.79 0.06,0.02 c -0.05,-0.01 -0.01,-0.01 -0.06,-0.02 m 1.07,0.27 0.07,0.01 -0.07,-0.01 m 1.06,0.26 0.1,0.02 c -0.05,-0.01 -0.05,-0.01 -0.1,-0.02 m 1.08,0.26 0.1,0.03 c -0.05,-0.02 -0.05,-0.02 -0.1,-0.03 m 1.07,0.26 0.12,0.03 c -0.05,-0.01 -0.07,-0.02 -0.12,-0.03 m 1.1,0.27 0.09,0.02 c -0.05,-0.01 -0.05,-0.01 -0.09,-0.02 m 1.08,0.26 0.09,0.02 c -0.05,-0.01 -0.05,-0.01 -0.09,-0.02 m 1.09,0.26 0.06,0.01 -0.06,-0.01 m 1.09,0.26 0.05,0.01 -0.05,-0.01 m 3.25,0.76 0.01,0.01 -0.01,-0.01 m 1.05,0.25 0.06,0.01 -0.06,-0.01 m 1.08,0.25 0.07,0.01 -0.07,-0.01 m 1.07,0.24 0.1,0.03 c -0.04,-0.01 -0.05,-0.01 -0.1,-0.03 m 1.09,0.25 0.1,0.03 -0.1,-0.03 m 1.09,0.25 0.11,0.03 c -0.05,-0.01 -0.06,-0.02 -0.11,-0.03 m 1.09,0.25 0.11,0.02 c -0.04,-0.01 -0.06,-0.01 -0.11,-0.02 m 1.09,0.24 c 0.05,0.01 0.08,0.02 0.12,0.03 -0.05,-0.01 -0.07,-0.02 -0.12,-0.03 m 1.11,0.25 0.08,0.02 -0.08,-0.02 m 1.1,0.25 0.05,0.01 c -0.05,-0.01 0,0 -0.05,-0.01 m 1.11,0.24 c 39.78,8.78 79.52,14.64 119.05,17.74 -39.52,-3.1 -79.28,-8.96 -119.05,-17.74"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.333333, 0, 0, -1.333333, -120.000002, 512.666695)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1, 0, 0, 0.1, 0.850327, 0.425164)",
    id: "g12"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath20)",
    id: "g16"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#131212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3399.68,1659.06 204.03,-142.96 c 35.33,-24.75 79.38,-27.99 116.51,-12.5 20.45,8.54 38.79,22.77 52.43,42.22 38.36,54.78 25.03,130.56 -29.73,168.94 l -204.86,143.54 -138.38,-199.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#131212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2381.25,1375.71 -42.05,-246.98 c -11.22,-65.91 33.29,-128.67 99.21,-139.91 23.42,-3.988 46.43,-0.949 66.88,7.59 37.13,15.49 65.8,49.11 73.04,91.61 l 42.39,248.97 -239.47,38.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#fbbf09",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1855.36,2959.45 c -1.43,1.18 -2.77,2.45 -4.41,3.45 -16.47,9.95 -33.87,18.77 -52.22,26.31 -206.87,85.03 -444.87,-22.16 -515.63,-238.79 -54.6,-167.1 13.88,-353.41 162.54,-447.27 36.86,-23.27 75.44,-38.96 114.48,-48.35 6.86,-1.66 13.51,-1.14 19.62,0.78 8.59,259.11 106.4,508.28 275.62,703.87"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g42"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath48)",
    id: "g44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "url(#radialGradient54)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1568.71,2253.18 c -2.73,0 -5.51,0.32 -8.33,1 -39.04,9.38 -77.62,25.08 -114.48,48.35 -69.04,43.6 -120.8,107.13 -150.95,179.43 30.19,-72.04 81.84,-135.34 150.69,-178.81 36.86,-23.27 75.44,-38.96 114.48,-48.35 2.82,-0.68 5.61,-0.99 8.34,-0.99 3.9,0 7.69,0.64 11.28,1.77 1.62,48.86 6.41,97.37 14.26,145.23 0.13,-0.03 0.25,-0.07 0.38,-0.11 -7.9,-48.03 -12.75,-96.71 -14.38,-145.75 -3.6,-1.12 -7.39,-1.77 -11.29,-1.77"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "#e7ab10",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1568.46,2253.81 c -2.73,0 -5.52,0.31 -8.34,0.99 -39.04,9.39 -77.62,25.08 -114.48,48.35 -68.85,43.47 -120.5,106.77 -150.69,178.81 -34.77,83.35 -40.83,178.35 -11.6,267.84 10.12,30.95 23.74,59.56 40.09,85.8 -25.18,-151.43 43.54,-308.44 175.98,-392.06 30.57,-19.31 62.36,-33.13 94.58,-42.73 -7.85,-47.86 -12.64,-96.37 -14.26,-145.23 -3.59,-1.13 -7.38,-1.77 -11.28,-1.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#fbbf09",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2774.96,3350.55 c 0.17,1.85 0.2,3.68 0.65,5.55 4.51,18.71 10.46,37.29 18,55.63 85.02,206.89 328.59,300.73 532.37,198.72 157.2,-78.68 241.52,-258.38 203.72,-430.08 -9.37,-42.57 -25.34,-81.03 -46.12,-115.39 -3.64,-6.04 -8.7,-10.41 -14.35,-13.41 -190.27,176.09 -436.21,281.76 -694.27,298.98"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g62"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath68)",
    id: "g64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path76",
    style: {
      fill: "url(#radialGradient74)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3469.5,3050.95 c -36.02,33.32 -74.04,64.1 -113.74,92.26 0.06,0.12 0.12,0.23 0.18,0.35 39.55,-28.08 77.41,-58.78 113.29,-91.99 5.65,3 10.71,7.37 14.35,13.41 20.78,34.36 36.75,72.82 46.12,115.39 17.57,79.79 8.76,161.3 -21.47,233.61 30.43,-72.46 39.34,-154.22 21.73,-234.23 -9.37,-42.57 -25.34,-81.04 -46.12,-115.4 -3.64,-6.04 -8.69,-10.4 -14.34,-13.4"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    style: {
      fill: "#e7ab10",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3469.23,3051.57 c -35.88,33.21 -73.74,63.91 -113.29,91.99 15.84,29.66 28.35,61.98 36.12,97.29 33.69,152.97 -29.63,312.24 -155.01,400.82 30.15,-6.83 60.08,-17.27 89.19,-31.84 83.95,-42.01 147.1,-112.82 181.99,-195.85 30.23,-72.31 39.04,-153.82 21.47,-233.61 -9.37,-42.57 -25.34,-81.03 -46.12,-115.39 -3.64,-6.04 -8.7,-10.41 -14.35,-13.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    style: {
      fill: "#f7b30b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3664.84,3454.55 c -0.41,-18.09 27.71,-22.02 28.13,-3.78 1.2,52.65 -14.95,100.55 -43.69,138.27 -7.62,-5.42 -15.12,-10.95 -22.46,-16.54 24.88,-31.92 39.06,-72.57 38.02,-117.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    style: {
      fill: "#fbbf09",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3499.98,3670.44 c -18.17,1.75 -21.98,-26.37 -3.78,-28.13 54.4,-5.24 100.42,-31.07 130.62,-69.81 7.34,5.59 14.84,11.12 22.46,16.54 -34.24,44.92 -86.4,75.33 -149.3,81.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    style: {
      fill: "#f7b30b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3731.68,3637.35 c 31.36,-49.53 48.53,-109.01 46.37,-173.33 -0.6,-18.12 27.52,-22.02 28.13,-3.78 2.31,68.92 -15.32,133.25 -48,187.31 -8.9,-2.93 -17.74,-6.33 -26.5,-10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    style: {
      fill: "#fbbf09",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3502.5,3804.63 c -18.17,1.56 -21.99,-26.56 -3.78,-28.13 99.91,-8.56 183.88,-61.64 232.96,-139.15 8.76,3.87 17.6,7.27 26.5,10.2 -52.65,87.13 -144.49,147.54 -255.68,157.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    style: {
      fill: "#fbbf09",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3887.44,2835.23 c -21.12,12.23 -44.55,-18.27 -23.14,-30.66 68.41,-39.6 121.72,-128.17 149.81,-224.54 13.56,-0.37 27.14,-1.05 40.76,-2.16 -29.08,109.57 -88.68,211.78 -167.43,257.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    style: {
      fill: "#f7b30b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4014.11,2580.03 c 28.09,-96.36 30.95,-200.51 -1.55,-271.26 -10.34,-22.51 25.22,-37.04 35.53,-14.6 34.45,75.01 33.63,182.49 6.78,283.7 -13.62,1.11 -27.2,1.79 -40.76,2.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    style: {
      fill: "#fbbf09",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3633.09,2902.53 c -21.61,11.98 -36.01,-23.66 -14.6,-35.52 104.01,-57.64 181.75,-176.84 222.08,-308.75 12.28,3.83 24.65,7.08 37.1,9.84 -44.12,142.41 -130.24,271.07 -244.58,334.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    style: {
      fill: "#f7b30b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3840.57,2558.26 c 42.16,-137.9 43.43,-289.7 -9.38,-399.66 -10.73,-22.32 24.85,-36.82 35.52,-14.6 57.27,119.26 55.97,278.83 10.96,424.1 -12.45,-2.76 -24.82,-6.01 -37.1,-9.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    style: {
      fill: "#f7b30b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1134.96,2369.22 c 14.19,-13.41 32.37,10.94 18.29,24.24 -46.34,43.78 -66.82,101.34 -61.95,158.2 -10.19,-0.74 -20.36,-1.77 -30.5,-3.14 -3.41,-64.79 21.85,-129.88 74.16,-179.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    style: {
      fill: "#fbbf09",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1113.04,2681.37 c -32.79,-40.23 -49.81,-86.47 -52.24,-132.85 10.14,1.37 20.31,2.4 30.5,3.14 3.35,39.04 18.54,77.75 45.98,111.42 12.36,15.18 -11.9,33.44 -24.24,18.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    style: {
      fill: "#fbbf09",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 957.074,2522.31 c -7.656,83.27 17.516,169.36 76.196,239.84 12.52,15.04 -11.75,33.28 -24.24,18.29 -66.296,-79.63 -92.507,-177 -80.878,-270.38 9.481,4.48 19.153,8.5 28.922,12.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    style: {
      fill: "#f7b30b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 957.074,2522.31 c -9.769,-3.75 -19.441,-7.77 -28.922,-12.25 10.09,-81.03 48.668,-159.06 114.398,-219.86 14.35,-13.27 32.54,11.07 18.29,24.24 -62.055,57.41 -96.735,131.45 -103.766,207.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    style: {
      fill: "#f7b30b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1550.06,1495.49 c -5.08,-15.42 -9.8,-30.89 -14.1,-46.4 47.99,-62.79 106.49,-112.68 165.99,-134.35 23.2,-8.45 37.87,27.05 14.6,35.52 -60.43,22.01 -120.07,77.24 -166.49,145.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    style: {
      fill: "#fbbf09",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1468.28,1804.31 c 6.24,23.94 -31.92,28.72 -38.07,5.11 -27.91,-106.98 23.45,-252.66 105.75,-360.33 4.3,15.51 9.02,30.98 14.1,46.4 -65.96,96.61 -105.2,219.03 -81.78,308.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108",
    style: {
      fill: "#fbbf09",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1596.73,2022.99 c 6.62,23.56 -28.84,38.39 -35.52,14.6 -33.02,-117.51 -8.21,-257.56 52.39,-382.68 6.93,15.24 13.98,30.32 21.07,45.26 -47.19,107.91 -65.57,224.45 -37.94,322.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110",
    style: {
      fill: "#f7b30b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1950.85,1373.63 c -130.84,45.13 -251.02,177.58 -316.18,326.54 -7.09,-14.94 -14.14,-30.02 -21.07,-45.26 70.5,-145.54 189.47,-270.87 322.65,-316.8 23.32,-8.04 38.02,27.45 14.6,35.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112",
    style: {
      fill: "#03a5ca",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3584.19,1747.8 c 132.21,253.24 152.48,561.32 47.98,837.88 -1.52,4.84 -3.28,9.75 -5.47,14.73 -1.94,4.9 -4.09,9.47 -6.39,13.84 -171.35,374.84 -547.01,615.39 -962.62,595.96 -87.68,-4.1 -173.25,-20.47 -254.87,-47.33 l -148.43,-62.58 c -233.76,-121.85 -418.03,-334.94 -496.07,-593.31 -121.14,-401.05 26.04,-850.92 368.4,-1096.1 92.94,-66.56 194.75,-115.01 300.65,-145.67 l 239.48,-38.73 c 207.93,-8.22 418.27,47.61 598.78,166.87 67.81,44.79 127.82,97.2 180.18,155.21 l 138.38,199.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    style: {
      fill: "#131212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2402.6,3163.41 -27.95,66.93 70.95,29.62 -75.87,181.74 -289.78,-120.97 75.88,-181.75 70.19,29.31 28.15,-67.46 148.43,62.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    style: {
      fill: "#64cbd3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 3299.06,1573.63 C 3031.1,1329.7 2634.2,1276.35 2311.24,1439.98 c -713.12,361.33 -572.22,1457.4 207.47,1629.37 414.32,91.39 826.55,-132.49 995.27,-516.16 133.77,-338.2 57.8,-731.3 -214.92,-979.56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g118"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath124)",
    id: "g120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path126",
    style: {
      fill: "#0995b8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2172.45,2905.66 h 465.313 v 181.43 H 2172.45 Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path128",
    style: {
      fill: "#45c1c7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2220.61,1492.86 c -498.28,331.49 -480.04,1067 -48.16,1412.8 l 0.02,0.02 c 0.26,0.21 0.5,0.39 0.75,0.6 l 0.03,0.02 c 0.26,0.21 0.49,0.39 0.75,0.6 l 0.03,0.02 c 0.25,0.2 0.48,0.38 0.74,0.59 l 0.01,0.01 c 0.23,0.18 0.48,0.38 0.71,0.56 0.03,0.03 0.06,0.05 0.09,0.08 0.23,0.18 0.44,0.34 0.67,0.52 0.06,0.05 0.06,0.05 0.13,0.1 0.22,0.18 0.4,0.32 0.62,0.5 0.07,0.05 0.11,0.08 0.18,0.14 0.19,0.15 0.4,0.32 0.6,0.47 0.07,0.05 0.12,0.1 0.19,0.15 0.2,0.16 0.39,0.31 0.59,0.46 0.07,0.06 0.14,0.12 0.21,0.17 0.2,0.15 0.37,0.29 0.57,0.44 0.07,0.06 0.16,0.13 0.23,0.19 0.2,0.15 0.36,0.28 0.55,0.43 0.1,0.08 0.15,0.12 0.26,0.2 0.16,0.12 0.36,0.28 0.53,0.41 0.1,0.08 0.17,0.13 0.27,0.21 0.13,0.1 0.3,0.23 0.43,0.33 0.13,0.11 0.25,0.2 0.38,0.3 0.13,0.11 0.23,0.18 0.36,0.28 0.14,0.11 0.31,0.24 0.45,0.35 0.13,0.1 0.2,0.15 0.33,0.26 0.14,0.1 0.34,0.26 0.47,0.36 0.13,0.1 0.17,0.13 0.31,0.24 0.17,0.13 0.36,0.27 0.53,0.41 0.06,0.05 0.18,0.14 0.25,0.19 0.17,0.13 0.39,0.3 0.57,0.44 0.09,0.07 0.12,0.09 0.22,0.17 0.21,0.16 0.42,0.32 0.63,0.48 0.07,0.05 0.1,0.08 0.17,0.13 0.27,0.21 0.47,0.36 0.74,0.57 0.03,0.02 0.03,0.02 0.06,0.04 0.96,0.74 1.92,1.47 2.89,2.2 l 0.01,0.01 c 62.07,46.98 132.23,86.1 210.21,115.17 l 0.01,0.01 c 0.35,0.13 0.66,0.24 1.01,0.37 0.04,0.02 0.04,0.01 0.08,0.03 0.35,0.13 0.59,0.22 0.93,0.35 l 0.12,0.04 c 0.34,0.13 0.58,0.22 0.93,0.34 0.04,0.02 0.05,0.02 0.09,0.04 0.35,0.13 0.64,0.23 0.99,0.36 l 0.03,0.01 c 0.35,0.13 0.66,0.24 1.01,0.37 l 0.04,0.02 c 1.22,0.44 2.43,0.88 3.65,1.32 0.04,0.02 0.02,0.01 0.06,0.02 0.35,0.13 0.61,0.22 0.96,0.35 0.04,0.01 0.13,0.04 0.17,0.06 0.31,0.11 0.56,0.2 0.86,0.31 0.05,0.01 0.14,0.05 0.19,0.06 0.26,0.1 0.58,0.21 0.85,0.31 0.04,0.01 0.14,0.05 0.18,0.06 0.26,0.09 0.6,0.21 0.86,0.31 0.09,0.03 0.09,0.03 0.18,0.06 0.26,0.09 0.54,0.19 0.81,0.29 0.08,0.02 0.18,0.06 0.26,0.09 0.26,0.09 0.5,0.17 0.76,0.27 0.08,0.03 0.19,0.06 0.28,0.09 0.22,0.08 0.47,0.17 0.69,0.25 0.13,0.04 0.23,0.08 0.35,0.12 0.18,0.06 0.45,0.16 0.63,0.22 0.12,0.04 0.28,0.1 0.41,0.14 0.18,0.06 0.28,0.1 0.45,0.16 0.17,0.06 0.42,0.14 0.59,0.2 0.17,0.06 0.27,0.1 0.45,0.16 0.17,0.06 0.4,0.14 0.57,0.2 0.18,0.06 0.29,0.1 0.46,0.16 0.17,0.06 0.32,0.11 0.48,0.16 0.18,0.06 0.38,0.13 0.55,0.19 0.13,0.05 0.3,0.1 0.42,0.15 0.23,0.07 0.39,0.13 0.61,0.21 0.13,0.04 0.28,0.09 0.41,0.13 0.22,0.08 0.4,0.14 0.62,0.22 0.17,0.05 0.25,0.08 0.42,0.14 0.17,0.06 0.41,0.14 0.58,0.2 0.17,0.06 0.29,0.09 0.46,0.15 0.17,0.06 0.38,0.13 0.56,0.19 0.17,0.06 0.3,0.1 0.47,0.16 0.18,0.06 0.36,0.12 0.54,0.18 0.17,0.06 0.32,0.11 0.49,0.17 0.18,0.06 0.32,0.1 0.49,0.16 0.17,0.06 0.37,0.13 0.54,0.18 0.14,0.05 0.27,0.09 0.4,0.14 0.22,0.07 0.44,0.14 0.65,0.21 0.13,0.05 0.24,0.08 0.37,0.13 0.22,0.07 0.45,0.15 0.67,0.22 0.13,0.04 0.25,0.08 0.38,0.13 0.22,0.07 0.44,0.14 0.65,0.21 0.14,0.05 0.24,0.08 0.38,0.13 0.21,0.07 0.47,0.15 0.68,0.22 0.14,0.04 0.21,0.07 0.34,0.11 0.22,0.07 0.49,0.16 0.7,0.23 0.14,0.05 0.2,0.07 0.33,0.11 0.22,0.07 0.49,0.16 0.7,0.23 0.09,0.03 0.24,0.08 0.33,0.1 0.17,0.06 0.45,0.15 0.62,0.21 0.13,0.04 0.28,0.09 0.41,0.13 0.17,0.06 0.42,0.14 0.59,0.19 0.18,0.06 0.25,0.08 0.43,0.14 0.17,0.06 0.42,0.14 0.59,0.19 0.14,0.05 0.27,0.09 0.41,0.13 0.21,0.07 0.42,0.14 0.63,0.21 0.09,0.03 0.22,0.07 0.31,0.1 0.22,0.07 0.51,0.16 0.72,0.23 0.14,0.04 0.2,0.06 0.33,0.1 0.26,0.08 0.47,0.15 0.73,0.23 0.09,0.03 0.22,0.07 0.31,0.1 0.25,0.08 0.47,0.15 0.73,0.23 0.09,0.03 0.22,0.07 0.31,0.1 0.26,0.08 0.5,0.16 0.75,0.24 0.09,0.03 0.19,0.06 0.28,0.09 0.26,0.08 0.49,0.15 0.75,0.23 0.14,0.05 0.17,0.06 0.31,0.1 0.26,0.08 0.49,0.16 0.75,0.24 0.09,0.02 0.19,0.05 0.28,0.08 0.26,0.08 0.51,0.16 0.77,0.24 0.09,0.03 0.18,0.06 0.27,0.09 0.26,0.08 0.49,0.15 0.74,0.23 0.09,0.03 0.19,0.05 0.28,0.08 0.26,0.08 0.45,0.14 0.7,0.22 0.1,0.03 0.24,0.07 0.33,0.1 0.26,0.08 0.46,0.14 0.72,0.22 0.05,0.02 0.2,0.06 0.24,0.08 0.26,0.08 0.55,0.16 0.8,0.24 0.09,0.03 0.13,0.04 0.22,0.07 0.26,0.08 0.6,0.18 0.86,0.26 0.04,0.01 0.13,0.04 0.17,0.05 0.26,0.08 0.59,0.18 0.85,0.26 0.05,0.02 0.18,0.06 0.23,0.07 0.25,0.08 0.56,0.17 0.82,0.25 0.09,0.03 0.13,0.04 0.22,0.07 0.26,0.07 0.56,0.17 0.82,0.24 0.09,0.03 0.15,0.05 0.24,0.07 0.26,0.08 0.57,0.17 0.83,0.25 0.04,0.02 0.15,0.05 0.2,0.06 0.26,0.08 0.58,0.18 0.85,0.26 0.04,0.01 0.16,0.05 0.21,0.06 0.3,0.09 0.55,0.16 0.85,0.25 0.09,0.03 0.07,0.02 0.16,0.05 0.31,0.09 0.6,0.18 0.91,0.27 0.04,0.01 0.07,0.02 0.11,0.03 0.31,0.09 0.65,0.19 0.96,0.28 l 0.02,0.01 c 0.31,0.09 0.65,0.19 0.95,0.28 0.05,0.01 0.06,0.02 0.11,0.03 0.3,0.09 0.61,0.18 0.92,0.27 0.04,0.01 0.09,0.02 0.13,0.04 0.31,0.09 0.61,0.17 0.91,0.26 0.05,0.01 0.11,0.03 0.15,0.04 0.31,0.09 0.59,0.18 0.9,0.26 0.04,0.02 0.12,0.04 0.16,0.05 0.27,0.08 0.62,0.18 0.88,0.25 0.05,0.02 0.14,0.04 0.19,0.06 0.26,0.07 0.6,0.17 0.86,0.24 0.1,0.03 0.11,0.03 0.2,0.06 0.26,0.08 0.62,0.18 0.88,0.25 0.04,0.01 0.11,0.03 0.16,0.05 0.31,0.08 0.6,0.17 0.91,0.25 0.05,0.02 0.08,0.03 0.13,0.04 0.31,0.09 0.63,0.18 0.93,0.27 l 0.12,0.03 c 0.31,0.08 0.64,0.18 0.95,0.26 0.04,0.02 0.05,0.02 0.09,0.03 0.35,0.1 0.62,0.17 0.97,0.27 l 0.06,0.02 c 0.35,0.1 0.62,0.17 0.98,0.27 0.04,0.01 0,0 0.05,0.01 0.35,0.1 0.62,0.18 0.97,0.27 0.05,0.02 0.05,0.02 0.1,0.03 0.31,0.09 0.63,0.18 0.94,0.26 0.05,0.01 0.09,0.02 0.13,0.04 0.31,0.08 0.63,0.17 0.94,0.25 0.04,0.02 0.07,0.02 0.12,0.04 0.35,0.09 0.6,0.16 0.95,0.26 0.05,0.01 0.06,0.01 0.1,0.02 0.35,0.1 0.6,0.17 0.96,0.26 l 0.11,0.04 c 0.36,0.09 0.6,0.16 0.95,0.25 0.05,0.02 0.07,0.02 0.11,0.03 0.36,0.1 0.6,0.16 0.96,0.26 0.04,0.01 0.06,0.02 0.11,0.03 0.31,0.08 0.66,0.17 0.96,0.26 l 0.09,0.02 c 0.35,0.09 0.63,0.17 0.99,0.26 0.04,0.01 0.01,0.01 0.06,0.02 0.7,0.19 1.35,0.36 2.06,0.55 h 0.02 c 0.36,0.09 0.69,0.18 1.05,0.27 0.04,0.02 -0.03,0 0.02,0.01 0.35,0.09 0.67,0.18 1.03,0.27 l 0.04,0.01 c 0.36,0.09 0.65,0.17 1.01,0.26 0.04,0.01 0.03,0.01 0.07,0.02 0.36,0.09 0.63,0.16 0.98,0.26 0.05,0.01 0.06,0.01 0.1,0.02 0.36,0.09 0.62,0.16 0.98,0.25 l 0.09,0.03 c 0.36,0.09 0.62,0.15 0.97,0.24 0.05,0.02 0.07,0.02 0.12,0.03 0.35,0.09 0.6,0.16 0.96,0.25 0.05,0.01 0.06,0.01 0.11,0.03 0.35,0.09 0.62,0.15 0.97,0.24 l 0.08,0.02 c 0.36,0.09 0.66,0.17 1.02,0.26 h 0.02 c 1.07,0.27 2.09,0.53 3.16,0.79 0.05,0.01 0.01,0.01 0.06,0.02 0.36,0.09 0.65,0.16 1.01,0.25 l 0.07,0.01 c 0.36,0.09 0.63,0.16 0.99,0.25 0.05,0.01 0.05,0.01 0.1,0.02 0.36,0.09 0.62,0.16 0.98,0.24 0.05,0.01 0.05,0.01 0.1,0.03 0.35,0.08 0.61,0.14 0.97,0.23 0.05,0.01 0.07,0.02 0.12,0.03 0.36,0.09 0.62,0.15 0.98,0.24 0.04,0.01 0.04,0.01 0.09,0.02 0.35,0.09 0.63,0.15 0.99,0.24 0.04,0.01 0.04,0.01 0.09,0.02 0.36,0.09 0.64,0.15 1,0.24 l 0.06,0.01 c 0.36,0.09 0.67,0.16 1.03,0.25 l 0.05,0.01 c 1.08,0.26 2.12,0.5 3.2,0.75 l 0.01,0.01 c 0.36,0.08 0.68,0.15 1.04,0.24 l 0.06,0.01 c 0.36,0.09 0.66,0.15 1.02,0.24 l 0.07,0.01 c 0.37,0.09 0.64,0.15 1,0.23 0.05,0.02 0.06,0.02 0.1,0.03 0.36,0.08 0.63,0.14 0.99,0.22 l 0.1,0.03 c 0.37,0.08 0.63,0.14 0.99,0.22 0.05,0.01 0.06,0.02 0.11,0.03 0.36,0.08 0.62,0.14 0.98,0.22 0.05,0.01 0.07,0.01 0.11,0.02 0.37,0.09 0.62,0.14 0.98,0.22 0.05,0.01 0.07,0.02 0.12,0.03 0.32,0.07 0.67,0.15 0.99,0.22 l 0.08,0.02 c 0.36,0.08 0.66,0.15 1.02,0.23 0.05,0.01 0,0 0.05,0.01 0.36,0.08 0.69,0.15 1.06,0.23 v 0 c 39.77,8.78 79.53,14.64 119.05,17.74 22.44,1.76 44.82,2.63 67.06,2.63 232.23,0 452.01,-94.46 614.93,-254.74 -164.92,111.49 -380.2,164.44 -593.58,164.44 -35.29,0 -70.57,-1.45 -105.52,-4.32 -780.24,-64.15 -852.96,-1050.78 -400.04,-1502.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    style: {
      fill: "#1994a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3147.42,1931.19 c -8.83,0 -17.81,1.69 -26.48,5.26 l -380.29,156.28 50.21,130.13 383.1,-157.43 c 35.61,-14.63 52.62,-55.38 37.98,-91 -11.07,-26.94 -37.09,-43.24 -64.52,-43.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2497.68,2915.86 c 16.06,-38.48 -2.11,-82.7 -40.6,-98.77 -38.48,-16.06 -82.7,2.11 -98.76,40.6 -16.07,38.48 2.1,82.7 40.59,98.77 38.48,16.06 82.7,-2.11 98.77,-40.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2177.4,2716.51 c 33.16,-25.3 39.53,-72.68 14.24,-105.83 -25.3,-33.16 -72.68,-39.53 -105.83,-14.23 -33.16,25.29 -39.53,72.67 -14.23,105.83 25.29,33.15 72.67,39.52 105.82,14.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1999.72,2383.73 c 41.36,-5.33 70.57,-43.18 65.24,-84.54 -5.33,-41.36 -43.18,-70.57 -84.54,-65.23 -41.35,5.32 -70.56,43.17 -65.23,84.53 5.32,41.35 43.17,70.56 84.53,65.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2012.23,2006.69 c 38.49,16.06 82.71,-2.11 98.77,-40.6 16.07,-38.47 -2.11,-82.69 -40.59,-98.76 -38.48,-16.06 -82.7,2.1 -98.76,40.59 -16.07,38.49 2.1,82.7 40.58,98.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2211.59,1686.42 c 25.29,33.15 72.67,39.53 105.83,14.22 33.15,-25.29 39.52,-72.67 14.23,-105.83 -25.29,-33.14 -72.68,-39.52 -105.83,-14.22 -33.15,25.29 -39.53,72.67 -14.23,105.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2544.37,1508.73 c 5.33,41.37 43.18,70.58 84.54,65.24 41.35,-5.33 70.56,-43.17 65.24,-84.54 -5.33,-41.35 -43.18,-70.56 -84.54,-65.23 -41.36,5.33 -70.57,43.17 -65.24,84.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2921.41,1521.25 c -16.06,38.48 2.11,82.7 40.59,98.76 38.48,16.06 82.7,-2.1 98.77,-40.59 16.06,-38.48 -2.11,-82.7 -40.59,-98.77 -38.49,-16.06 -82.7,2.11 -98.77,40.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3241.68,1720.61 c -33.15,25.29 -39.53,72.67 -14.23,105.83 25.29,33.15 72.67,39.52 105.83,14.22 33.15,-25.29 39.52,-72.67 14.23,-105.83 -25.3,-33.15 -72.68,-39.52 -105.83,-14.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3419.36,2053.38 c -41.36,5.33 -70.57,43.18 -65.24,84.54 5.33,41.36 43.18,70.57 84.54,65.23 41.36,-5.32 70.57,-43.17 65.24,-84.53 -5.33,-41.35 -43.18,-70.56 -84.54,-65.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3406.85,2430.42 c -38.48,-16.06 -82.7,2.11 -98.77,40.59 -16.06,38.49 2.11,82.71 40.59,98.77 38.48,16.06 82.71,-2.11 98.77,-40.59 16.07,-38.48 -2.11,-82.7 -40.59,-98.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3207.5,2750.69 c -25.3,-33.15 -72.68,-39.52 -105.83,-14.23 -33.16,25.29 -39.53,72.68 -14.24,105.83 25.3,33.15 72.68,39.53 105.83,14.23 33.16,-25.29 39.53,-72.67 14.24,-105.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2874.71,2928.37 c -5.33,-41.35 -43.17,-70.56 -84.53,-65.24 -41.36,5.33 -70.57,43.18 -65.24,84.54 5.33,41.36 43.18,70.57 84.53,65.24 41.36,-5.33 70.57,-43.17 65.24,-84.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156",
    style: {
      fill: "#e71835",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2835.05,2245.01 c -1.64,7.73 -3.84,15.46 -6.99,23.02 -17.41,41.69 -54.27,69.15 -95.63,76.7 l -168.05,402.54 c -14.83,35.53 -55.67,52.31 -91.21,37.48 -35.53,-14.84 -52.32,-55.67 -37.48,-91.21 L 2603.74,2291 c -23.73,-34.71 -30.11,-80.23 -12.71,-121.92 27.33,-65.46 102.53,-96.37 167.98,-69.04 9.43,3.93 17.9,9.09 25.82,14.83 l 315.8,-129.77 c 35.62,-14.64 76.36,2.37 91.01,37.99 14.63,35.61 -2.38,76.35 -38,90.99 l -318.59,130.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2830.23,2268.94 c 27.83,-66.65 -3.65,-143.25 -70.3,-171.08 -66.66,-27.82 -143.26,3.65 -171.08,70.31 -27.83,66.65 3.65,143.25 70.31,171.08 66.66,27.83 143.25,-3.65 171.07,-70.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    style: {
      fill: "#d7d6d6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2769.38,2243.54 c 13.79,-33.05 -1.81,-71.03 -34.86,-84.82 -33.05,-13.8 -71.02,1.81 -84.81,34.85 -13.8,33.05 1.8,71.03 34.85,84.82 33.05,13.8 71.02,-1.81 84.82,-34.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(21, 28, 98)"
    },
    d: "m 3472.92,716.852 c 0,-41.422 -435.59,-74.993 -972.92,-74.993 -537.32,0 -972.92,33.571 -972.92,74.993 0,41.41 435.6,74.988 972.92,74.988 537.33,0 972.92,-33.578 972.92,-74.988"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.2af871e71d77a42a29761360bf16e724.svg";
export { ForwardRef as ReactComponent };